import React from 'react'
import styled from 'styled-components'

function ContactHero() {
  return (
    <Container>
      <Wrap>
        <h2 className='shine'>WE’D LOVE TO HEAR FROM YOU!</h2>
        <p className='shine'>Our team of passionate storytellers is ready to collaborate and craft something extraordinary with you. Let’s transform your vision into stunning reality. </p>

      </Wrap>
    </Container>
  )
}

const Container = styled.div`
    width: 100%;
    height: 80vh;
    background: linear-gradient(180deg, #0000004A 0%, #000000 130%), url('./banner.png');
    background-size: cover;
    display: flex;
    justify-content: flex-end;

    @media only screen and (max-width: 1200px){
      justify-content: center;
      height: 70vh;
    }

`

const Wrap = styled.div`
    width: 40%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center; 
    flex-direction: column;

    @media only screen and (max-width: 1200px){
      width: 99%;
    }

    

    h2{ 
      font-size: 48px;
      text-align: center; 
      text-transform: uppercase;

      @media only screen and (max-width: 1200px){
        font-size: 30px;
      }
    }
    p{
        color: #fff;  
        font-size: 18px;
        padding: 0 15px;
        margin: 20px 0;
        text-transform: uppercase;
        font-weight: 800;
        text-align: center;

        @media only screen and (max-width: 1200px){
          font-size: 20px;
        }
      }

`

export default ContactHero
